export function getBaselineImportPayloadErrorMessages(data) {
	if (data && typeof data === "object") {
		// Guard uploader marker payloads (parse errors, invalid file types, or non-JSON uploads)
		// before confirmation/mutation paths run.
		if (data.parseError || data.invalidType || (data.fileType && data.fileType !== "json")) {
			return ["Invalid import payload.", " ", "Please verify the JSON file format."];
		}

		if (Array.isArray(data.scenario_configs) || Array.isArray(data.scenario_item_configs)) {
			return [
				"Invalid Baseline import file.",
				" ",
				"Scenario export data cannot be imported through the Baseline import flow.",
			];
		}

		// Keep Baseline guard aligned with backend import requirements so malformed
		// payloads are rejected before baseline mutation is attempted.
		if (
			!Array.isArray(data.baseline_configs) ||
			!Array.isArray(data.baseline_items) ||
			!Array.isArray(data.baseline_accesses)
		) {
			return ["Invalid import payload.", " ", "Please verify the JSON file format."];
		}

		// Baseline import flow relies on source metadata to build import name/from_id.
		// Reject incomplete payloads early rather than letting malformed data reach mutation prep.
		const sourceName = typeof data.name === "string" ? data.name.trim() : "";
		const sourceId = Number(data.id);
		if (!sourceName || !Number.isFinite(sourceId) || sourceId <= 0) {
			return ["Invalid import payload.", " ", "Please verify the JSON file format."];
		}
	}

	if (!data || typeof data !== "object") {
		return ["Invalid import payload.", " ", "Please verify the JSON file format."];
	}

	return null;
}
